import type { SVGProps } from 'react';

const SvgSubtitleOffFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2.82324 2.11615C3.11614 1.82326 3.5909 1.82326 3.88379 2.11615L4.16699 2.39936C4.19614 2.44542 4.22937 2.49005 4.26953 2.53022L22.9863 21.247C23.1695 21.5369 23.1364 21.9241 22.8838 22.1767C22.591 22.4694 22.1161 22.4693 21.8232 22.1767L19.3965 19.7499H4C3.0336 19.7499 2.25015 18.9663 2.25 17.9999V5.99994C2.25 5.0669 2.98027 4.30552 3.90039 4.25385L2.82324 3.1767C2.5304 2.88386 2.53049 2.40906 2.82324 2.11615ZM7 14.2499C6.58579 14.2499 6.25 14.5857 6.25 14.9999C6.25015 15.414 6.58588 15.7499 7 15.7499H14C14.3816 15.7499 14.695 15.4644 14.7422 15.0956L13.8965 14.2499H7ZM7 9.99994C6.44772 9.99994 6 10.4477 6 10.9999C6.00015 11.5521 6.44781 11.9999 7 11.9999C7.55219 11.9999 7.99985 11.5521 8 10.9999C8 10.4477 7.55228 9.99994 7 9.99994ZM9.90332 10.2568C9.53483 10.3043 9.25 10.6185 9.25 10.9999C9.25015 11.414 9.58588 11.7499 10 11.7499H11.3965L9.90332 10.2568Z'
      fill='currentColor'
    />
    <path
      d='M20 4.24994C20.9665 4.24994 21.75 5.03344 21.75 5.99994V17.8896L15.6104 11.7499H17C17.4141 11.7499 17.7498 11.414 17.75 10.9999C17.75 10.5857 17.4142 10.2499 17 10.2499H14.1104L8.11035 4.24994H20Z'
      fill='currentColor'
    />
  </svg>
);
export default SvgSubtitleOffFilled;
